// Udyan 29 Sep: product-page tabs "You may also like" (related) and "Pairs well with" (complementary).
// Each tab is rendered first with its backup collection. This swaps in Shopify's recommendations for the product
// when there are any (complementary = the pairings set in Search & Discovery; related = Shopify's automatic ones).
// If there are none, the backup collection stays, so a tab is never empty.
// Udyan 2 Oct: recommendations are fetched only when the section comes near the screen (not at page load), and a tab
// that still waits in a <template> (assets/ut-tabs.js) gets its cards swapped inside the template, so it opens ready.
(function () {
  if (window.utRecsReady) return;
  window.utRecsReady = true;

  var requested = {};

  function matching(root, url) {
    var out = [];
    root.querySelectorAll('[data-ut-recs-url]').forEach(function (el) {
      if (el.getAttribute('data-ut-recs-url') === url) out.push(el);
    });
    return out;
  }

  // The tab on the page if it is built, otherwise the copy waiting in its <template>
  function targets(url) {
    var out = matching(document, url);
    if (out.length) return out;
    document.querySelectorAll('template[data-ut-tab]').forEach(function (template) {
      out = out.concat(matching(template.content, url));
    });
    return out;
  }

  function urls(section) {
    var out = [];
    var add = function (el) {
      var url = el.getAttribute('data-ut-recs-url');
      if (url && out.indexOf(url) === -1) out.push(url);
    };
    section.querySelectorAll('[data-ut-recs-url]').forEach(add);
    section.querySelectorAll('template[data-ut-tab]').forEach(function (template) {
      template.content.querySelectorAll('[data-ut-recs-url]').forEach(add);
    });
    return out;
  }

  function swap(slider, items) {
    if (slider.getAttribute('data-ut-recs-source')) return;
    var ul = slider.querySelector('ul.product-grid');
    if (!ul) return;
    // The first backup card carries the card stylesheets (printed once per section); keep them on the page
    ul.querySelectorAll('link[rel="stylesheet"]').forEach(function (link) {
      ul.parentNode.insertBefore(link, ul);
    });
    ul.innerHTML = '';
    items.forEach(function (li) {
      ul.appendChild(ul.ownerDocument.importNode(li, true));
    });
    slider.setAttribute('data-ut-recs-source', slider.getAttribute('data-ut-recs'));
    if (typeof slider.resetPages === 'function') {
      try {
        slider.resetPages();
      } catch (e) {}
    }
  }

  function load(url) {
    if (requested[url]) return;
    requested[url] = true;
    fetch(url)
      .then(function (r) {
        return r.ok ? r.text() : '';
      })
      .then(function (html) {
        if (!html) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var list = doc.querySelector('[data-ut-recs-list]');
        var items = list ? Array.prototype.slice.call(list.querySelectorAll(':scope > li')) : [];
        if (!items.length) return; // keep the backup collection
        targets(url).forEach(function (slider) {
          swap(slider, items);
        });
      })
      .catch(function () {});
  }

  function boot() {
    document.querySelectorAll('.collection').forEach(function (section) {
      var list = urls(section);
      if (!list.length) return;
      var go = function () {
        list.forEach(load);
      };
      if (!('IntersectionObserver' in window)) return go();
      var observer = new IntersectionObserver(
        function (entries) {
          if (!entries.some(function (e) { return e.isIntersecting; })) return;
          observer.disconnect();
          go();
        },
        { rootMargin: '1200px 0px' }
      );
      observer.observe(section);
    });

    // A tapped tab loads straight away (in case the section was reached before the observer fired)
    document.addEventListener('click', function (event) {
      var tab = event.target.closest && event.target.closest('.tab-title');
      var section = tab && tab.closest('.collection');
      if (section) urls(section).forEach(load);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
